import { unpack, filterByKey } from '@/legacy/lib//util';
import Model from '@/legacy/lib//Model';

export default class Map extends Model
{
  constructor (props)
  {
    super ()

    Object.assign (
      this,
      unpack (props || {}, [
        'id',
        'name',
        'approved',
        'variants',
        'clans',
        'info',
        'ladders',
        'variables',
        'schemes',
        'sids'
      ])
    );
  }

  getStatsId (key)
  {
    return filterByKey (
      this
        .variants
        .find (v => v.name === key.map)
        .stats,

      key
    ) [0].id;
  }
}